<template>
  <div id="PrintQuotation" class="preview-quotation">
    <div class="flex-row-between header-info">
      <div class="logo">
        <auth-img
          tag="el-image"
          :src="require('../assets/logo_leybold_sub.png')"
          fit="contain"
        ></auth-img>
      </div>
      <ul class="header-info">
        <li>
          <span class="title">客户名称：</span>
          <span class="value">{{ quotation.customer.name }}</span>
        </li>
        <li>
          <span class="title">项目：</span>
          <span class="value">{{ quotation.order_info.project_name }}</span>
        </li>
        <!-- <li v-if="quotation.order_info.devices.length > 0">
          <span class="title">机器型号：</span>
          <span class="value">
            <template v-for="device in quotation.order_info.devices">{{ device.item_category.name }}</template>
          </span>
        </li>
        <li v-if="quotation.order_info.devices.length > 0">
          <span class="title">机器系列号：</span>
          <span class="value">
            <template v-for="device in quotation.order_info.devices">{{ device.serial_number }}</template>
          </span>
        </li> -->
        <li>
          <span class="title">致：</span>
          <span class="value" v-if="quotation.order_info.customer_contact">{{
            showParam(quotation.order_info.customer_contact.name)
          }}</span>
        </li>
        <li>
          <span class="title">电话：</span>
          <span class="value" v-if="quotation.order_info.customer_contact">{{
            showParam(quotation.order_info.customer_contact.mobile)
          }}</span>
        </li>
        <li>
          <span class="title">邮箱：</span>
          <span class="value" v-if="quotation.order_info.customer_contact">{{
            showParam(quotation.order_info.customer_contact.email)
          }}</span>
        </li>
      </ul>
    </div>
    <div class="mt-20">
      <h2>报价单(报价单位:人民币CNY)</h2>
      <p class="flex-row-between mt-10">
        <span>报价编号: {{ quotation.number }}</span>
        <span
          >报价日期: {{ formatTime(quotation.created_at || new Date()) }}</span
        >
      </p>
    </div>
    <div>
      <ul class="devices">
        <li
          v-for="(device, index) in quotation.order_info.devices"
          :key="device.id"
        >
          <div class="device-header">
            <div class="flex-row-between">
              <div>
                设备{{ index + 1 }}：{{
                  device.customer_device.serial_number || '无'
                }}
              </div>
              <!-- <div class="device-select">
                <label for>工况</label>
                <span>{{ device.working_condition }}</span>
                <label for>运行时长</label>
                <span>{{ device.running_time }}H</span>
              </div> -->
            </div>
          </div>
          <el-table :data="device.items" style="width: 100%" :border="true">
            <el-table-column
              prop="item.part_number"
              label="件号"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="item.description"
              label="描述"
            ></el-table-column>
            <el-table-column
              prop="count"
              label="数量"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="item.price" label="单价(不含税)" width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="item.price" label="总价(不含税)" width="160">
              <template slot-scope="scope">
                <span>
                  {{ numberMul(scope.row.price, scope.row.count).toFixed(2) }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </li>
      </ul>
      <el-table
        :show-header="quotation.order_info.devices.length == 0"
        v-if="quotation.order_info.products.length > 0"
        :data="quotation.order_info.products"
        style="width: 100%"
        :border="true"
      >
        <el-table-column label="件号">
          <template slot-scope="scope">
            <div>{{ scope.row.item.part_number }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="item.description" label="描述"></el-table-column>
        <el-table-column
          prop="count"
          label="数量"
          width="60"
          align="center"
        ></el-table-column>
        <el-table-column prop="item.price" label="单价(不含税)" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.price.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="item.price" label="总价(不含税)" width="110">
          <template slot-scope="scope">
            <span>
              {{ numberMul(scope.row.price, scope.row.count).toFixed(2) }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <template v-for="device in quotation.order_info.devices">
        <template v-for="pk in device.packages">
          <p class="item-package-header mt-10">{{ pk.name }}</p>
          <el-table
            :data="pk.items"
            style="width: 100%"
            empty-text
            :show-header="false"
            header-row-class-name="item-package"
            :border="true"
          >
            <el-table-column prop="part_number" width="160"></el-table-column>
            <el-table-column prop="name"></el-table-column>
            <el-table-column
              prop="count"
              label
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column prop="price" width="160">
              <template slot-scope="scope">
                <span>{{ numberMul(scope.row.price, 1.13).toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column width="160">
              <template slot-scope="scope">
                <span>
                  {{
                    numberMul(scope.row.price, 1.13 * scope.row.count).toFixed(
                      2
                    )
                  }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </template>
    </div>
    <div style="margin-top: 40px">
      <div class="header">
        <h2>结算</h2>
      </div>
      <ul class="fee-list">
        <li>
          <div class="title">小计</div>
          <div class="input"></div>
          <div class="amount">{{ math.show(fee.item) }}</div>
        </li>
        <li>
          <div class="title">税费</div>
          <div class="input"></div>
          <div class="amount">{{ math.show(fee.tax) }}</div>
        </li>
        <li>
          <div class="title">杂项</div>
          <div class="input"></div>
          <div>+</div>
          <div class="amount">{{ math.show(fee.labor) }}</div>
        </li>
        <li>
          <div class="title">折扣金额（含税）</div>
          <!-- <div class="input">
            <span v-if="quotation.order_info.discount > 5">
              约{{ math.show(fee.discount) }}%
            </span>
          </div> -->
          <div>-</div>
          <div class="amount">
            {{ math.show(quotation.order_info.discount_value) }}
          </div>
        </li>
        <li>
          <div class="title" style="font-size: 14px">合计</div>
          <div class="input"></div>
          <div class="amount" style="font-size: 14px">
            {{ math.show(fee.total) }}
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="flex-row-between" style="margin-top: 60px">
      <span>{{ dealerName }}</span>
      <span>客户确认：</span>
      <span style="width: 200px">日期：</span>
    </div> -->
    <div class="header" style="margin-top: 40px">
      <h2>其他信息</h2>
    </div>
    <ul class="info mt-10">
      <!-- <li>
        <span class="title">备注：</span>
        <span>{{ showParam(quotation.order_info.remark) }}</span>
      </li> -->
      <!-- <li>
        <span class="title">报价期：</span
        ><span>{{ showParam(quotation.order_info.expire_date, true) }}</span>
      </li>-->
      <!-- <li>
        <span class="title">到货期：</span>
        <span>{{ showParam(quotation.order_info.delivery_date, true) }}</span>
      </li> -->
      <li>
        <span class="title">合同联系人：</span>
        <span>{{ quotation.user.name }}</span>
      </li>
    </ul>
    <ul class="info">
      <li>
        <span class="title">收货地址：</span>
        <span>{{ showParam(quotation.order_info.shipping_address) }}</span>
      </li>
      <li>
        <span class="title">收货人及电话：</span>
        <span>
          {{ showParam(quotation.order_info.consignee_name) }}
          {{ showParam(quotation.order_info.consignee_mobile) }}
        </span>
      </li>
      <li>
        <span class="title">收票地址：</span>
        <span>{{
          showParam(quotation.order_info.invoice_shipping_address)
        }}</span>
      </li>
      <li>
        <span class="title">收票人及电话：</span>
        <span>
          {{ showParam(quotation.order_info.invoice_consignee_name) }}
          {{ showParam(quotation.order_info.invoice_consignee_mobile) }}
        </span>
      </li>
    </ul>
    <div class="ql-remark-display">
      <div class="ql-editor" v-html="quotation.order_info.remark"></div>
    </div>
  </div>
</template>

<script>
import { numberMul, formatTime } from '@/util/index'
import math from '@/util/math'
import store from '@/store/store'

export default {
  props: {
    quotation: {
      type: Object,
    },
    fee: {
      type: Object,
    },
  },
  data() {
    return {
      numberMul,
      formatTime,
      math,
      dealerName: store.state.userInfo.dealer_name,
    }
  },
  computed: {},
  methods: {
    showParam(param, date) {
      if (param && param.length > 0) {
        if (date) {
          return formatTime(param)
        }
        return param
      } else {
        return '-'
      }
    },
  },
}
</script>

<style>
@media print {
  .el-table .el-table__body,
  .el-table .el-table__header {
    width: 100% !important;
  }
  .el-table th {
    display: table-cell !important;
  }
  .el-table .cell {
    width: 100% !important;
  }
}
</style>

<style scoped>
.preview-quotation {
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
  background-color: #fff;
  overflow: hidden;
  font-size: 14px;
}
.device-header {
  background-color: #fff7ea;
  border: 1px solid #e9d9c1;
  padding: 10px;
  margin-bottom: 10px;
  color: #3e4b5b;
}

/deep/.el-table .cell {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
/deep/.el-table td,
.el-table th {
  padding: 4px 0;
}
h3 {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.q-products {
  background-color: #dae1f2;
}

.q-products .title {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.total {
  margin-top: 10px;
  overflow: hidden;
}

.total .row {
  width: 100%;
  clear: both;
}

.total .row span {
  width: 120px;
  padding: 12px 10px;
  box-sizing: border-box;
}

.total .row span.title {
  width: 110px;
  color: #909399;
}

.device-select {
  text-align: left;
}

.device-select label {
  color: #999;
  margin-left: 10px;
  margin-right: 3px;
}
.devices li {
  margin-bottom: 20px;
}

.devices li:first-child {
  margin-top: 10px;
}

.profit {
  display: block;
  border: 1px dashed #5c9bd5;
  padding: 10px;
  margin-top: 20px;
  color: #5c9bd5;
}

.info-form .el-form-item {
  margin-top: 10px;
  margin-bottom: 0;
}
.del-device {
  border: 0 none;
  background: #fff;
}

.number-info p {
  margin: 0;
}
.number-info .sub {
  display: block;
  color: #adb5bd;
  line-height: 1.3;
}

.number-info strong {
  display: block;
  font-size: 1.5rem;
  line-height: 1.3;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.number-info strong span {
  margin-left: 4px;
}

.header-info {
  align-items: flex-start;
}
.logo .el-image {
  max-width: 120px !important;
}
.header-info ul {
  margin-right: 20px;
  width: 400px;
}
.header-info li .title {
  width: 100px;
  text-align: right;
  display: inline-block;
  color: #777;
}
.header-info li {
  padding: 2px 0;
}
.header-info li .value {
  color: #000;
}
h2 {
  font-size: 16px;
}
.item-package {
  border: 0 none;
}
.item-package-header {
  border-bottom: 1px solid #ebeef5;
  padding: 10px;
  line-height: 23px;
  color: #adb5be;
  margin-bottom: 0;
}

.info li {
  padding: 3px 0;
}
.info li .title {
  display: inline-block;
  text-align: left;
}

.page-break {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
}
</style>
